/**
 * Remove números inválidos de uma string separada por ponto e vírgula
 * @param {string} phones - String com números separados por ponto e vírgula
 * @return {string} - String com apenas os números válidos
 */
export const validatePhones = (phones) => {
  if (!phones || typeof phones !== 'string') {
    return ''
  }

  // Aceita formatos: 11999999999, 1199999999, 51999999999, 5199999999
  const phoneRegex =
    /^(1[1-9]|2[1-9]|3[1-9]|4[1-9]|5[1-9]|6[1-9]|7[1-9]|8[1-9]|9[1-9])([0-9]{8,9})$/

  const validNumbers = phones
    .split(';')
    .map((number) => number.trim())
    .filter((number) => {
      const cleanNumber = number.replace(/[^\d]/g, '')
      return phoneRegex.test(cleanNumber)
    })

  const uniqueNumbers = [...new Set(validNumbers)]

  return uniqueNumbers.join(';')
}
